module.exports = __webpack_public_path__ + "img/panama.055f09b.webp";